__turbopack_context__.v({
  "className": "bricolage_grotesque_213b2399-module__t6yc9W__className",
});
